'use client';
import {
  useSkipLinkTarget,
  SkipLinkTarget as SkipLinkTargetType,
} from '../context/SkipLinkContext';

/**
 * Client-only leaf that registers a page's skip link target with the global
 * `SkipLinkProvider`. Lets Server Components register a target without
 * calling the `useSkipLinkTarget` hook themselves.
 */
const SkipLinkTarget = (props: SkipLinkTargetType): null => {
  useSkipLinkTarget(props);

  return null;
};

export default SkipLinkTarget;
